import { SimpleSelect } from '@aloft/toolkit-sui';

import { UseFormRegister } from 'react-hook-form';

import { ObjectiveCharacteristicsFormInput } from '../schObjectiveCharacteristics.ts';

export function PorchPatioDeckTypeSelect({
  register,
  name,
}: {
  register: UseFormRegister<ObjectiveCharacteristicsFormInput>;
  name: 'porch.type' | 'patio.type' | 'deck.type';
}) {
  return (
    <SimpleSelect {...register(name)} label="Type" size="sm" required>
      <option value="covered">Covered</option>
      <option value="uncovered">Uncovered</option>
      <option value="screen">Screen</option>
    </SimpleSelect>
  );
}
